import React from "react";
import { useLocation } from "react-router-dom";
import { shouldExcludeHeaderFooter } from "../../config/navigationConfig";
import { lazy, Suspense } from "react";
import ConsentModal from "./ConsentModal";
const CommonHeader = lazy(() => import("./CommonHeader"));
const CommonFooter = lazy(() => import("./CommonFooter"));

export default function Layout({ children }) {
  const location = useLocation();
  const excludeHeaderFooter = shouldExcludeHeaderFooter(location.pathname);

  return (
    <div className="layout-wrapper">
      <Suspense fallback={null}>
        {!excludeHeaderFooter && <CommonHeader />}
      </Suspense>
      <main className="layout-main">{children}</main>
      <Suspense fallback={null}>
        {!excludeHeaderFooter && <CommonFooter />}
      </Suspense>
      <ConsentModal />
    </div>
  );
}
